import { render, staticRenderFns } from "./head.vue?vue&type=template&id=68c24d14&scoped=true&"
import script from "./head.js?vue&type=script&lang=js&"
export * from "./head.js?vue&type=script&lang=js&"
import style0 from "../../index.scss?vue&type=style&index=0&id=68c24d14&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68c24d14",
  null
  
)

export default component.exports